import * as React from "react";
const ClockIcon = ({
  height = 20,
  width = 20,
  color = "black",
  onClick = () => {},
  ...props
}) => (
  <svg
    onClick={onClick}
    cursor="pointer"
    width={width}
    height={height}
    viewBox="0 0 17 20"
    fill='none'
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.5 19.125C12.9183 19.125 16.5 15.5433 16.5 11.125C16.5 6.70672 12.9183 3.125 8.5 3.125C4.08172 3.125 0.5 6.70672 0.5 11.125C0.5 15.5433 4.08172 19.125 8.5 19.125Z"
      stroke={color}
    />
    <path
      d="M10.5 0.625H6.5M14 5.125L15.5 3.625M8.5 8.125V11.125H5.5"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default ClockIcon;
